/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { WidgetProps } from "../../../../_foundation/constants/seo-config";
import { breadcrumbsSelector } from "../../../../redux/selectors/catalog";
import { RESET_BREADCRUMBS } from "../../../../redux/action-types/catalog";

export const useBreadcrumbTrail = () => {
  const dispatch = useDispatch();
  const breadcrumbs = useSelector(breadcrumbsSelector);

  useEffect(() => {
    return () => {
      dispatch({ type: RESET_BREADCRUMBS });
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    breadcrumbs,
  };
};

export const withBreadcrumbTrailWidget =
  (WrapComponent: React.ComponentType<any>): React.FC<WidgetProps> =>
  () => {
    const { breadcrumbs } = useBreadcrumbTrail();
    return <WrapComponent {...{ breadcrumbs }}></WrapComponent>;
  };
